import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as webViewerFeaturePackagesService from '../services/webViewerFeaturePackages';
import { entitiesAdapter } from './common/adapter';

const initialState = {
  isFetching: false,
  fetchingError: null,
};

const sliceName = 'webViewerFeaturePackages';

export const fetchAllWebViewerFeaturePackages = createAsyncThunk(
  `${sliceName}/fetchAllWebViewerFeaturePackages`,
  (args, thunkAPI) => {
    return webViewerFeaturePackagesService.getWebViewerFeaturePackages().catch((error) => {
      error.clientMessage = "Can't get web viewer feature packages from server";
      return thunkAPI.rejectWithValue(error);
    });
  }
);

const webViewerFeaturePackages = createSlice({
  name: sliceName,
  initialState: entitiesAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: {
    [fetchAllWebViewerFeaturePackages.fulfilled]: (state, action) => {
      state.isFetching = false;
      entitiesAdapter.setAll(
        state,
        action.payload.map((featurePackage) => ({
          ...featurePackage,
          name: featurePackage.isDeprecated
            ? featurePackage.name + ' (Deprecated)'
            : featurePackage.name,
        }))
      );
    },

    [fetchAllWebViewerFeaturePackages.pending]: (state) => {
      state.isFetching = true;
      state.fetchingError = null;
    },

    [fetchAllWebViewerFeaturePackages.rejected]: (state, action) => {
      state.isFetching = false;
      state.fetchingError = action.payload;
    },
  },
});

const { reducer } = webViewerFeaturePackages;

const webViewerFeaturePackagesAdapterSelectors = entitiesAdapter.getSelectors(
  (state) => state[sliceName]
);

export const webViewerFeaturePackagesSelectors = {
  ...webViewerFeaturePackagesAdapterSelectors,
  isFetching: (state) => state[sliceName].isFetching,
  fetchingError: (state) => state[sliceName].fetchingError,
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/webViewerFeaturePackagesSlice.js